import { module } from 'angular';

import { CHECK_PRECONDITIONS_STAGE } from './checkPreconditionsStage';
import { STAGE_CORE_MODULE } from '../core/stage.core.module';

export const CHECK_PRECONDITIONS_STAGE_MODULE = 'spinnaker.pipelines.stage.checkPreconditions';
module(CHECK_PRECONDITIONS_STAGE_MODULE, [
  require('../stage.module.js').name,
  STAGE_CORE_MODULE,
  CHECK_PRECONDITIONS_STAGE,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/checkPreconditions/checkPreconditionsStage.module.ts